'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMantineTheme, getThemeColor } from '@mantine/core';

function AreaSplit({ offset, id, colors, fillOpacity }) {
  const theme = useMantineTheme();
  return /* @__PURE__ */ jsxs("linearGradient", { id, x1: "0", y1: "0", x2: "0", y2: "1", children: [
    /* @__PURE__ */ jsx(
      "stop",
      {
        offset,
        stopColor: getThemeColor(colors[0], theme),
        stopOpacity: fillOpacity ?? 0.2
      }
    ),
    /* @__PURE__ */ jsx(
      "stop",
      {
        offset,
        stopColor: getThemeColor(colors[1], theme),
        stopOpacity: fillOpacity ?? 0.2
      }
    )
  ] });
}
AreaSplit.displayName = "@mantine/charts/AreaSplit";

export { AreaSplit };
//# sourceMappingURL=AreaSplit.mjs.map
